import { createSlice } from '@reduxjs/toolkit';

const designationsSlice = createSlice({
  name: 'designations',
  initialState: {
    data: [],
    loading: false,
    error: null,
    lastFetched: null,
  },
  reducers: {
    fetchDesignationsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchDesignationsSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
      state.lastFetched = Date.now();
    },
    fetchDesignationsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchDesignationsStart, fetchDesignationsSuccess, fetchDesignationsFailure } = designationsSlice.actions;
export default designationsSlice.reducer;
